(function () {
  'use strict';
  const SCREEN_HANDLE = 'high-diffusion-espresso-shower-screen-breville';
  const SCREEN_KITS = { '53693915365683': 'br54', '53693915398451': 'br58', '54078927929651': 'jet' };
  function resolveKit(model, data) {
    const assignments = (model.assignmentList || []).filter(a => data.products[a.productId]?.handle === SCREEN_HANDLE);
    const variants = [...new Set(assignments.map(a => String(a.defaultVariantId || '')))];
    if (variants.length !== 1 || !SCREEN_KITS[variants[0]]) return null;
    if (assignments.some(a => !(a.allowedVariantIds || []).map(String).includes(variants[0]))) return null;
    return { key: SCREEN_KITS[variants[0]], screenId: variants[0], productId: assignments[0].productId };
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { resolveKit }; return; }
  const titles = { br54: 'Breville 54mm Extraction Bundle', br58: 'Breville 58mm Extraction Bundle', jet: 'Oracle Jet Extraction Bundle' };
  const baskets = { br54: '18g', br58: '20g', jet: '20g' };
  function initialise(root) {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const $ = selector => root.querySelector(selector);
    const config = JSON.parse($('[data-bundle-config]').textContent);
    const shopRoot = config.root.replace(/\/$/, '') + '/';
    const toggle = $('[data-picker-toggle]'), panel = $('[data-picker-panel]'), search = $('[data-machine-search]');
    const results = $('[data-machine-results]'), add = $('[data-add]'), status = $('[data-status]');
    const qty = $('input[name="quantity"]');
    let data, models = [], selected = null, currentKit = null, adding = false;
    const setText = (selector, text) => { $(selector).textContent = text; };
    function measureHero() {
      const top = root.getBoundingClientRect().top + window.scrollY;
      root.style.setProperty('--pbb-top', Math.max(0, Math.min(top, 200)) + 'px');
    }
    measureHero();
    window.addEventListener('resize', measureHero, { passive: true });
    window.addEventListener('load', measureHero, { once: true });
    let pickerFrame = 0;
    function positionPicker() {
      pickerFrame = 0;
      if (panel.hidden) return;
      const viewport = window.visualViewport;
      const viewTop = viewport?.offsetTop || 0;
      const viewBottom = viewTop + (viewport?.height || window.innerHeight);
      const field = toggle.getBoundingClientRect();
      const owner = $('.pbb__picker').getBoundingClientRect();
      let bottom = viewBottom - 12;
      const bar = document.getElementById('shopify-section-top-bar');
      if (bar && getComputedStyle(bar).position === 'fixed') {
        const rect = bar.getBoundingClientRect();
        if (rect.top > viewTop && rect.top < bottom && rect.bottom <= viewBottom + 2) bottom = rect.top - 12;
      }
      if (desktopInfo.matches) bottom = Math.min(bottom, infoNav.getBoundingClientRect().top - 12);
      const below = bottom - field.bottom;
      const above = field.top - viewTop - 90;
      const opensAbove = below < 210 && above > below;
      const height = Math.max(0, Math.min(360, opensAbove ? above : below));
      panel.style.maxHeight = height + 'px';
      panel.style.top = (opensAbove ? field.top - owner.top - panel.getBoundingClientRect().height : field.bottom - owner.top) + 'px';
      panel.dataset.placement = opensAbove ? 'above' : 'below';
    }
    function schedulePicker() {
      if (!panel.hidden && !pickerFrame) pickerFrame = requestAnimationFrame(positionPicker);
    }
    window.addEventListener('resize', schedulePicker, { passive: true });
    window.addEventListener('scroll', schedulePicker, { passive: true });
    window.visualViewport?.addEventListener('resize', schedulePicker, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedulePicker, { passive: true });
    function message(text, error = false) { status.textContent = text; status.dataset.error = String(error); }
    function quantity() { const value = Math.max(1, Math.min(99, Math.trunc(Number(qty.value)) || 1)); qty.value = String(value); return value; }
    function picker(open, focusSearch = false) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      root.toggleAttribute('data-picker-open', open);
      if (open) {
        search.value = ''; renderOptions();
        const field = toggle.getBoundingClientRect();
        const viewport = window.visualViewport;
        const viewTop = viewport?.offsetTop || 0;
        const viewBottom = viewTop + (viewport?.height || window.innerHeight);
        if (field.top < viewTop + 120 || field.bottom > viewBottom - 70) {
          toggle.scrollIntoView({ block: 'center', behavior: 'instant' });
        }
        if (focusSearch) search.focus({ preventScroll: true });
        positionPicker();
      }
    }
    function renderOptions() {
      const term = search.value.trim().toLocaleLowerCase();
      const filtered = models.filter(m => [m.name, ...(m.aliases || [])].join(' ').toLocaleLowerCase().includes(term));
      results.replaceChildren();
      filtered.forEach(model => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'pbb__option';
        button.setAttribute('aria-pressed', String(selected?.id === model.id));
        if (model.image) { const image = new Image(60, 60); image.src = model.image; image.alt = ''; image.loading = 'lazy'; button.append(image); }
        const name = document.createElement('span'); name.textContent = model.name;
        const arrow = document.createElement('span'); arrow.textContent = '›'; arrow.setAttribute('aria-hidden', 'true');
        button.append(name, arrow); button.addEventListener('click', event => selectModel(model, event.detail === 0)); results.append(button);
      });
      $('[data-search-empty]').hidden = filtered.length !== 0;
      schedulePicker();
    }
    function selectModel(model, returnFocus = false) {
      if (adding) return;
      const resolved = resolveKit(model, data);
      if (!resolved) { message('We could not confirm a bundle for this machine. Please contact our team.', true); return; }
      selected = model; currentKit = { ...config.kits[resolved.key], ...resolved };
      picker(false); root.dataset.state = 'selected'; root.dataset.kit = resolved.key;
      document.querySelectorAll('[data-bundle-review-key]').forEach(element => { element.hidden = element.dataset.bundleReviewKey !== resolved.key; });
      $('[data-pesado-reviews-link]').dataset.productId = String(config.kits[resolved.key].productId);
      setText('[data-selection-label]', model.name);
      setText('[data-match-label]', 'Matched to ' + model.name);
      setText('[data-machine-name]', model.name);
      $('[data-match]').hidden = false;
      const machineImage = $('[data-machine-image]');
      machineImage.src = model.image || ''; machineImage.alt = model.name;
      $('[data-machine-figure]').hidden = !model.image;
      setText('[data-bundle-title]', titles[resolved.key]);
      infoProduct.textContent = titles[resolved.key];
      setText('[data-bundle-summary]', 'HD shower screen kit + EP ' + baskets[resolved.key] + ' basket + Contact Mesh');
      const productImage = $('[data-bundle-image]');
      productImage.src = currentKit.image || config.kits.br58.image;
      productImage.alt = titles[resolved.key] + ': HD shower screen kit, Contact Mesh and EP ' + baskets[resolved.key] + ' basket';
      $('[data-image-note]').hidden = resolved.key !== 'jet' || !!currentKit.image;
      const displayPrice = currentKit.id ? currentKit.priceLabel : resolved.key === 'jet' ? config.kits.br58.priceLabel : '';
      setText('[data-price]', displayPrice || 'Price to be confirmed');
      setText('[data-compare]', currentKit.compareLabel || '');
      $('[data-compare]').hidden = !currentKit.id || !currentKit.compareLabel;
      add.disabled = !currentKit.id || !currentKit.available;
      setText('[data-add-label]', !currentKit.id ? 'Coming soon' : currentKit.available ? (currentKit.stockStatus === 'preorder' ? 'Pre order bundle' : 'Add bundle to cart') : 'Sold out');
      message(!currentKit.id ? 'This bundle is not yet available to order.' : currentKit.stockStatus === 'preorder' ? 'This bundle is available to pre-order.' : '');
      $('[data-cart-link]').hidden = true;
      root.querySelectorAll('[data-kit-content]').forEach(element => { element.hidden = element.dataset.kitContent !== resolved.key; });
      setText('[data-included-intro]', 'Your bundle for ' + model.name + '.');
      const notice = $('[data-compatibility-notice]'); notice.textContent = model.compatibilityNotice || ''; notice.hidden = !notice.textContent;
      const install = $('[data-install-link]');
      const source = data.products[resolved.productId]?.sources?.find(s => /youtube|installation/.test(s.type) && /^https:\/\//.test(s.url));
      install.hidden = !source || resolved.key === 'jet';
      if (!install.hidden) install.href = source.url;
      $('[data-install-prompt]').hidden = true;
      $('[data-jet-install]').hidden = resolved.key !== 'jet';
      const url = new URL(window.location.href); url.searchParams.set('machine', model.id); url.searchParams.delete('variant'); window.history.replaceState(null, '', url);
      if (window.matchMedia('(max-width: 900px)').matches) root.scrollIntoView({ block: 'start', behavior: 'instant' });
      else if (returnFocus) toggle.focus({ preventScroll: true });
    }
    // Desktop reading drawer; mobile retains the approved inline information panels.
    const desktopInfo = window.matchMedia('(min-width: 901px)');
    const infoDialog = $('[data-info-dialog]'), drawer = $('[data-info-drawer]');
    const infoNav = $('.pbb__info-nav'), infoBackdrop = $('[data-info-backdrop]');
    const infoTitle = $('[data-info-title]'), infoProduct = $('[data-info-product]');
    const infoScroll = $('[data-info-scroll]'), infoClose = $('[data-info-close]');
    const infoLabels = { overview: 'Overview', compatibility: 'Compatibility', specifications: 'Specifications', shipping: 'Shipping & Returns', installation: 'Installation', reviews: 'Reviews' };
    const infoBackground = [$('.pbb__hero'), $('.pbb__assurances'), $('.pbb__details')];
    const siteHeader = document.querySelector('.t4s-section-header');
    const shippingBar = document.getElementById('shopify-section-top-bar');
    let activeInfo = null, infoLocked = false, infoReturnFocus = null, infoFrame = 0;
    let savedOverflow = '', infoPageY = 0;
    function measureInfo() {
      infoFrame = 0;
      if (!desktopInfo.matches) return;
      const barRect = shippingBar?.getBoundingClientRect();
      const shippingHeight = barRect && getComputedStyle(shippingBar).position === 'fixed' && barRect.bottom <= window.innerHeight + 2 ? Math.max(0, window.innerHeight - barRect.top) : 0;
      root.style.setProperty('--pbb-shipping-height', shippingHeight + 'px');
      root.style.setProperty('--pbb-nav-height', infoNav.getBoundingClientRect().height + 'px');
      root.style.setProperty('--pbb-header-bottom', Math.max(0, siteHeader?.getBoundingClientRect().bottom || 0) + 'px');
      root.style.setProperty('--pbb-assurances-height', $('.pbb__assurances').getBoundingClientRect().height + 'px');
      root.style.setProperty('--pbb-hero-end', ($('.pbb__hero').getBoundingClientRect().bottom + window.scrollY) + 'px');
    }
    function scheduleInfo() { if (!infoFrame) infoFrame = requestAnimationFrame(measureInfo); }
    function syncInfoDrawer() {
      const modal = desktopInfo.matches && !!activeInfo;
      if (modal && !infoLocked) infoPageY = window.scrollY;
      root.toggleAttribute('data-info-open', modal);
      infoBackdrop.hidden = !modal;
      if (modal) {
        picker(false);
        infoDialog.setAttribute('role', 'dialog');
        infoDialog.setAttribute('aria-modal', 'true');
        infoDialog.setAttribute('aria-labelledby', infoTitle.id);
        if (!infoLocked) {
          infoReturnFocus = document.activeElement;
          savedOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          infoBackground.forEach(element => { element.inert = true; });
          infoLocked = true;
          requestAnimationFrame(() => { if (infoLocked) window.scrollTo({ top: infoPageY, behavior: 'instant' }); });
        }
        measureInfo();
        infoScroll.focus({ preventScroll: true });
      } else {
        infoDialog.removeAttribute('role');
        infoDialog.removeAttribute('aria-modal');
        infoDialog.removeAttribute('aria-labelledby');
        if (infoLocked) {
          document.body.style.overflow = savedOverflow;
          infoBackground.forEach(element => { element.inert = false; });
          infoLocked = false;
          if (infoReturnFocus?.isConnected) infoReturnFocus.focus({ preventScroll: true });
          if (desktopInfo.matches) window.scrollTo({ top: infoPageY, behavior: 'instant' });
        }
        measureInfo();
      }
    }
    function closeInfo() { if (activeInfo) showInfo(activeInfo, false); }
    infoClose.addEventListener('click', closeInfo);
    infoBackdrop.addEventListener('click', closeInfo);
    desktopInfo.addEventListener('change', syncInfoDrawer);
    window.addEventListener('resize', scheduleInfo, { passive: true });
    window.addEventListener('scroll', scheduleInfo, { passive: true });
    const infoObserver = new ResizeObserver(scheduleInfo);
    [siteHeader, shippingBar, infoNav, $('.pbb__hero'), $('.pbb__assurances')].filter(Boolean).forEach(element => infoObserver.observe(element));
    measureInfo();
    document.addEventListener('keydown', event => {
      if (!infoLocked) return;
      if (event.key === 'Escape') { event.preventDefault(); closeInfo(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...infoDialog.querySelectorAll('button, a[href], input, [tabindex="0"]')].filter(element => !element.disabled && element.getClientRects().length);
      const index = focusable.indexOf(document.activeElement);
      const next = event.shiftKey ? (index <= 0 ? focusable.length - 1 : index - 1) : (index + 1) % focusable.length;
      event.preventDefault();
      focusable[next]?.focus();
    });
    // The site's header and cart keep their existing actions when the reader is dismissed.
    siteHeader?.addEventListener('click', () => { if (infoLocked) closeInfo(); }, true);

    function showInfo(key, forceOpen) {
      const button = $('[data-info-toggle="' + key + '"]');
      if (!button) return;
      const open = forceOpen === true || button.getAttribute('aria-expanded') !== 'true';
      root.querySelectorAll('[data-info-toggle]').forEach(control => {
        const active = open && control.dataset.infoToggle === key;
        control.setAttribute('aria-expanded', String(active));
        control.querySelector('span').textContent = active ? '−' : '+';
      });
      root.querySelectorAll('[data-info-panel]').forEach(content => { content.hidden = !(open && content.dataset.infoPanel === key); });
      activeInfo = open ? key : null;
      drawer.hidden = !open;
      if (open) {
        infoTitle.textContent = infoLabels[key];
        infoProduct.textContent = $('[data-bundle-title]').textContent;
        infoScroll.scrollTop = 0;
      }
      syncInfoDrawer();
    }
    root.querySelectorAll('[data-info-toggle]').forEach(button => button.addEventListener('click', () => showInfo(button.dataset.infoToggle)));
    function openInfoHash() {
      const target = document.getElementById(window.location.hash.slice(1));
      if (target && root.contains(target) && target.dataset.infoPanel) showInfo(target.dataset.infoPanel, true);
    }
    window.addEventListener('hashchange', openInfoHash);
    openInfoHash();
    function cartContext() {
      const snapshot = data.publication || data.snapshot || {};
      return {
        label: 'Compatible with ' + selected.name, sourceHandle: currentKit.handle, sourceVariant: titles[currentKit.key], sourceVariantId: String(currentKit.id),
        family: selected.familyId || '', brandId: 'breville', modelId: selected.id, modelName: selected.name, machineSelection: true, snapshot,
        products: selected.products.map(id => ({ ...data.products[id], id, recommendationId: id, ...selected.assignments[id] })).filter(p => p.handle)
      };
    }
    async function addBundle(event) {
      event.preventDefault();
      if (adding || !selected || !currentKit?.id || !currentKit.available) return;
      adding = true; add.disabled = true; add.setAttribute('aria-busy', 'true'); setText('[data-add-label]', 'Adding…'); message('');
      root.querySelectorAll('[data-change-machine], [data-picker-toggle]').forEach(button => { button.disabled = true; });
      let added = false;
      try {
        const response = await fetch(shopRoot + 'cart/add.js', { method: 'POST', signal: AbortSignal.timeout(20000), headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(currentKit.id), quantity: quantity(), properties: { _pesado_compatibility_family: selected.familyId || '', _pesado_compatibility_machine: selected.name, _pesado_compatibility_brand_id: 'breville', _pesado_compatibility_model_id: selected.id, _pesado_compatibility_workflow: 'breville_bundle' } }] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'The bundle could not be added. Please try again.');
        added = true;
        message('Bundle added to your cart.'); $('[data-cart-link]').hidden = false;
        const context = cartContext();
        window.PesadoCartCompanion?.setContext?.(context);
        document.dispatchEvent(new CustomEvent('pesado:cart-recommendations', { detail: context }));
        const cartResponse = await fetch(shopRoot + 'cart.js', { signal: AbortSignal.timeout(15000), headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:update:count', { detail: { cart, item_count: cart.item_count } }));
        if (window.PesadoCartCompanion?.open) window.PesadoCartCompanion.open();
        else document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
      } catch (error) {
        const uncertain = error.name === 'TimeoutError' || error.name === 'TypeError';
        message(added ? 'Bundle added. Open your cart to review it.' : uncertain ? 'Connection interrupted. Check your cart before trying again.' : error.message || 'Unable to add the bundle. Please try again.', !added);
        if (uncertain) $('[data-cart-link]').hidden = false;
      } finally {
        adding = false; add.disabled = !currentKit.available; add.removeAttribute('aria-busy'); setText('[data-add-label]', !currentKit.id ? 'Coming soon' : currentKit.available ? (currentKit.stockStatus === 'preorder' ? 'Pre order bundle' : 'Add bundle to cart') : 'Sold out');
        root.querySelectorAll('[data-change-machine], [data-picker-toggle]').forEach(button => { button.disabled = false; });
      }
    }
    toggle.addEventListener('click', event => picker(panel.hidden, event.detail === 0));
    root.querySelectorAll('[data-change-machine]').forEach(button => button.addEventListener('click', event => picker(true, event.detail === 0)));
    search.addEventListener('input', renderOptions);
    root.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) { picker(false); (window.matchMedia('(max-width: 900px)').matches && selected ? $('[data-machine-figure] button') : toggle).focus(); } });
    document.addEventListener('click', event => { if (!panel.hidden && !$('.pbb__picker').contains(event.target) && !event.target.closest('[data-change-machine]')) picker(false); });
    $('[data-quantity-minus]').addEventListener('click', () => { qty.value = Math.max(1, quantity() - 1); });
    $('[data-quantity-plus]').addEventListener('click', () => { qty.value = Math.min(99, quantity() + 1); });
    qty.addEventListener('change', quantity); $('[data-bundle-form]').addEventListener('submit', addBundle);
    root.querySelectorAll('.pbb__quick-links a').forEach(link => link.addEventListener('click', event => {
      const target = root.querySelector(link.hash);
      if (target?.dataset.infoPanel) {
        if (desktopInfo.matches) { event.preventDefault(); event.stopPropagation(); }
        showInfo(target.dataset.infoPanel, true);
      }
    }));
    async function loadMachines() {
      try {
        data = window.PesadoCompatibilityData;
        if (!data || data.managerUnavailable) data = await Promise.race([window.PesadoCompatibilityReady || Promise.resolve(null), new Promise(resolve => setTimeout(() => resolve(null), 12000))]);
        const brand = data?.brands.find(brand => brand.id === 'breville');
        models = (brand?.models || []).filter(model => resolveKit(model, data));
        if (!models.length) throw new Error('The machine selector is temporarily unavailable. Please reload or contact our team.');
        toggle.disabled = false; setText('[data-selection-label]', 'Select your Breville');
        const requested = new URL(window.location.href).searchParams.get('machine');
        const match = requested && models.find(model => model.id === requested);
        if (match) selectModel(match);
      } catch (error) { setText('[data-selection-label]', 'Machine selector unavailable'); message(error.message, true); }
    }
    loadMachines();
  }
  function boot() { document.querySelectorAll('[data-breville-bundle]').forEach(initialise); }
  // Deferred scripts later in the layout initialise the shared Manager data.
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
